// setRandomRegisterUsername.js
'use strict';
import getRandomUsername from '../resource/getRandomUsername.js';
import getRegisterData from '../selector/getRegisterData.js';
import getNetworkingSummary from '../selector/getNetworkingSummary.js';
import fetchRandomUsernames from '../action/fetchRandomUsernames.js';
import fetchIsUsernameAvailable from '../action/fetchIsUsernameAvailable.js';
import setRegisterUsername from '../action/setRegisterUsername.js';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

const MAX_RENEW_TIMES = 30; // TODO: remote config
const selectPath = ['register'];
let randomUsernames = [];
let isRandomUsernamesFailed = false;
let renewTimes = 0;

/**
 * Set random register username
 * @kind action
 * @return {Promise} Action promise.
 */
const setRandomRegisterUsername = () => async (dispatch, getState) => {
  let username = undefined;
  let isUsernameAvailable = false;

  const previousUsername = getRegisterData(getState(), 'username');
  let currentUsername = previousUsername;

  dispatch({
    type: MERGE_OPERATION_DATA,
    payload: { selectPath, data: { isMakingUsername: true } },
  });

  while (
    renewTimes < MAX_RENEW_TIMES &&
    false === isUsernameAvailable &&
    previousUsername === currentUsername // prevent changing user typed username
  ) {
    // try to fill randomUsernames with api call
    if (!randomUsernames.length && !isRandomUsernamesFailed) {
      await dispatch(fetchRandomUsernames());
      randomUsernames = getRegisterData(getState(), 'randomUsernames') || [];
      if (!randomUsernames.length) {
        isRandomUsernamesFailed = true;
      }
    }

    [username] = randomUsernames.splice(0, 1);

    // generate on client side if api failed
    if (!username) {
      username = getRandomUsername({
        paddingNumber: Math.min(8, Math.floor(Math.log(10 * renewTimes))),
      });
    }

    await dispatch(fetchIsUsernameAvailable({ username }));
    isUsernameAvailable = !getNetworkingSummary(getState(), [
      'register',
      'isUsernameAvailable',
      username,
    ]).error;

    currentUsername = getRegisterData(getState(), 'username');
    ++renewTimes;
  }

  // prevent changing user inputed username
  if (username && previousUsername === currentUsername) {
    dispatch(setRegisterUsername({ username }));
  }

  return dispatch({
    type: MERGE_OPERATION_DATA,
    payload: { selectPath, data: { isMakingUsername: false } },
  });
};

export default setRandomRegisterUsername;
